<form [formGroup]="contratoForm" novalidate>
  <div class="container  border border-success rounded mt-2">
    <div id="divBottom"></div>
    <div class="alert alert-primary fade show alert-dismissible" role="alert">
      <!-- &nbsp; ->espacios de sangría -->
      <strong><i class="fa fa-info-circle" aria-hidden="true"></i></strong> IMPORTANTE: TE RECOMENDAMOS LEER LAS
      SIGUIENTES INSTRUCCIONES PARA TERMINAR CORRECTAMENTE TU MATRÍCULA ONLINE.<br><br>
      <strong>PASO 1 :</strong> Presiona “Solicitar tu clave”. Esto activará el envío de dos correos electrónicos
      con el remitente <a href="cloudsigner@esign-la.com"> cloudsigner@esign-la.com </a>. La información de cada
      correo es:<br>
      <dd>
        • Correo 1: recibirás una clave para la firma del contrato.
        <br> • Correo 2: encontrarás la confirmación de solicitud de tu certificado digital. Es importante hacer clic en
        el link donde dice opción A o copiar y pegar en tu navegador el link de la opción. <br>Este paso te permitirá
        generar el certificado de tu firma digital.
        <br> • Correo 3: recibirás este correo una vez que esté habilitada tu firma digital. El asunto de este correo es
        “Certificado Generado Satisfactoriamente”.
        <br>
      </dd>
      <br>
      <strong>PASO 2 :</strong> Ahora que ya tienes activa tu clave, sólo debes presionar “Solicitar Contrato” y
      realizar la firma digital con la clave enviada en el correo 1.<br>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row mt-3">

      <div class="col-md-6">
        <app-apibutton text="Solicita tu clave, para entregar las instrucciones de este paso"
                       (click)="esignInit()" [progress]='progress' [showSpinner]="false"></app-apibutton>
        <app-progress *ngIf="progress && progressButtonsSolicitarClave"></app-progress>
        <br>
        <app-apibutton text="Solicitar Contrato, para entregar las instrucciones de este paso"
                       (click)="SolicitarContrato()" [progress]="progress" [showSpinner]="false">
        </app-apibutton>
        <div class="alert " role="alert" *ngIf="inforamar"
             [ngClass]="{'alert-success':EstadoAlerta=='0','alert-warning':EstadoAlerta=='1','alert-danger':EstadoAlerta=='2'}">
          <h4 class="alert-heading">{{titulo}}</h4>
          <hr>
          <p class="mb-0">{{body}}</p>
          <app-progress *ngIf="progress"></app-progress>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="Firmantes" formControlName="Firmantes" disabled>
          <label class="form-check-label" style="font-weight: bold;">
            Estado del Proceso
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="Firmantes" formControlName="Firmantes" disabled>
          <label class="form-check-label" for="Firmantes">
            Firmantes
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="UsuarioEnrolado"
                 formControlName="UsuarioEnrolado" disabled>
          <label class="form-check-label" for="UsuarioEnrolado">
            Firmantes Enrolados
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="GeneracionContrato"
                 formControlName="GeneracionContrato" disabled>
          <label class="form-check-label" for="GeneracionContrato">
            Generación Contrato
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="BusquedaContrato"
                 formControlName="BusquedaContrato" disabled>
          <label class="form-check-label" for="BusquedaContrato">
            Búsqueda del Contrato
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="EstadoContrato" formControlName="EstadoContrato"
                 disabled>
          <label class="form-check-label" for="EstadoContrato">
            Estado del Contrato
          </label>
        </div>
        <app-apibutton text="Guardar y continuar" [progress]="progress" (click)="avanceFase()"
                       *ngIf="iframe && faseActual === '5'">
        </app-apibutton>
      </div>
    </div>

    <div class="card border border-success mt-3" *ngIf="openContrato">
      <div class="alert alert-info mt-2" role="alert">
        Te recomendamos leer con atención este contrato, verifica que todos tus datos estén correctos antes de firmar.
      </div>
      <div class="alert alert-info mt-2" role="alert">
        La clave para firmar este contrato la debes haber recibido en un correo electrónico con asunto "Clave para la
        firma digital de contrato Santo Tomás"
      </div>
      <h5 class="card-header">Contrato
        <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CON" role="button"
           aria-expanded="true" aria-controls="CON"></a>
      </h5>
      <div class="collapse show" id="CON">
        <div class="card-body" style="height: 1000px;">


          <iframe width="100%" height="100%" style="border: 0;" [src]="urlSafe" *ngIf="trx!==''"
                  title="Santo Tomás - Contrato Matrícula"></iframe>

        </div>
      </div>
    </div>
    <app-apibutton text="Guardar y continuar" [progress]="progress" (click)="avanceFase()"
                   *ngIf="iframe && faseActual === '5'">
    </app-apibutton>

  </div>
</form>

<!-- Modal eSign -->
<div class="modal fade" id="infoCorreoESign" tabindex="-1" aria-labelledby="infoCorreoESign" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <div class="modal-body">
        <p class="text-left">Estimado Postulante:</p>
        <p class="text-left">
          Recibirás dos correos electrónicos que debes revisar antes de continuar con el proceso. El primer correo
          contiene una clave adicional de seguridad con la cual podrás firmar el contrato digital más adelante, mientras
          que en el segundo correo la empresa acreditada para la firma digital pide generar un certificado de firma.
          Este paso es obligatorio realizarlo antes de proceder con tu firma digital.
        </p>
        <p class="text-left">
          Si el sistema te pidió ingresar datos de un apoderado, también debe generar el certificado antes de
          firmar el contrato.
        </p>
        <p class="text-left">
          Todos estos pasos son por tu seguridad y resguardo.
        </p>
        <p class="text-left">
          Atentamente,<br/> Dirección de Admisión,<br/> Santo Tomás
        </p>
      </div>
    </div>
  </div>
</div>
<!-- Modal eSign -->
